//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();

		document.body.style.setProperty('--space-top', document.getElementById('header').offsetHeight + document.getElementById('header').offsetTop + 'px');
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});
	
	//Click for booking
	document.getElementById('booking-cta-js').addEventListener('click', function(e){
		e.preventDefault();
		if(!this.classList.contains('open')){
			document.getElementById('booking-engine').classList.add('open');
			document.getElementById('header').classList.add('open-booking');
			this.classList.add('open');
			this.innerHTML="close"
			document.querySelector("body").classList.add('noscroll-m');
		} else {
			this.classList.remove('open');
			document.getElementById('booking-engine').classList.remove('open');
			document.getElementById('header').classList.remove('open-booking');
			this.innerHTML="Book Now";
			document.querySelector("body").classList.remove('noscroll-m')
		}
	});


	//mobile burger menu
	document.querySelector('.js-burger-menu').addEventListener('click', function(e){
		e.preventDefault();
		document.querySelector('.burger-menu').classList.add('open');
	});
	document.querySelector('.burger-cta').addEventListener('click', function(e){
		e.preventDefault();
		document.querySelector('.burger-menu').classList.add('open');
	});
	document.getElementById('burger-close').addEventListener('click', function(e){
		e.preventDefault();
		document.querySelector('.burger-menu').classList.remove('open');
	});


	//SUBNAVIGATION On MOBILE

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');
	$('.sub-sub-menu').hide();
	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).closest('.inner').removeClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$(this).next().slideUp(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				}).removeClass('menu-open');
			} else {
				$(this).closest('.inner').addClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
				$(this).next().addClass('menu-open').slideDown(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				});
			}
		}
	});

	//For accordion quad
	$('.accordion .accordion__content').hide();
	// $('.accordion .accordion__item:first').addClass("active").find(".accordion__content").slideDown();
	// $('.accordion .accordion__title:first').addClass("active");

	$('.accordion__item').click(function(e) {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this).find(".accordion__content").slideUp();
			$(this).find('.accordion__title').removeClass("active");

		} else {
			$(".accordion__item.active .accordion__content").slideUp();
			$(".accordion__item.active").removeClass("active");
			$('.accordion__title').removeClass("active");
			$(this).addClass("active").find(".accordion__content").slideDown();
			$(this).find('.accordion__title').addClass("active");
			
		}
	}); 

	//Open Drop Down
	$(".custom-select").click(function (e) {
		e.preventDefault();
	
		if ($(".custom-select-wrapper").hasClass("open-dropdown")) {
		  $(".custom-select-wrapper").removeClass("open-dropdown");
		  $(this).parent().parent().toggleClass("open-dropdown");
		} else {
		  $(this).parent().parent().toggleClass("open-dropdown");
		}
	  });
	
	  // On click get Current Selected tag Value
	
	  $("ul li").click(function (e) {
		if ($(".custom-select-wrapper").hasClass("open-dropdown")) {
		  var current_value = $(this).text();
		  $(".open-dropdown .custom-select").val(current_value);
		  $(".custom-select-wrapper").removeClass("open-dropdown");
		}
	  });
	
	  // close when click on Body
	   $("html").click(function (event) {
		if ($(event.target).closest(".custom-select").length === 0) {
		  $(".custom-select-wrapper").removeClass("open-dropdown");
		}
	  }); 
		
		$("#filter-reset").on("click",function(e){
			e.preventDefault();
			e.preventDefault();
			$("#type-of-event").val("");
			$("#venues").val("");
	})

	//placehorder for input date mobile
	$("input[type=date]").on("input", function () {
		if ($(this).val().length > 0) {
			$(this).addClass("full");
		} else {
			$(this).removeClass("full");
		}
		});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');

				// var logoUrl = site_url + "assets/svg/logo-blue.svg";
				// document.getElementsByClassName("header__logo")[0].getElementsByTagName("img")[0].setAttribute("src", logoUrl);

			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				// var logoUrl = site_url + "assets/svg/logo-blue.svg";
				// document.getElementsByClassName("header__logo")[0].getElementsByTagName("img")[0].setAttribute("src", logoUrl);
			
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			// var logoUrl = site_url + "assets/svg/logo.svg";
			// 	document.getElementsByClassName("header__logo")[0].getElementsByTagName("img")[0].setAttribute("src", logoUrl);

		}
		if(document.querySelector(".sitemap") || document.getElementById('gallery-category') ||document.getElementById('attractions') || document.getElementById('default')  && !document.getElementById('header').classList.contains('up')){
				
			document.getElementById('header').classList.add('up');
			// var logoUrl = site_url + "assets/svg/logo-blue.svg";
			// document.getElementsByClassName("header__logo")[0].getElementsByTagName("img")[0].setAttribute("src", logoUrl);
		}

	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}
/* Submenu on mobile */
function submenu(){
	var submenuHold = document.querySelectorAll('.sub-menu__hold');
	var allsublinks = document.querySelectorAll('.sub-menu a');
	if(allsublinks.length > 1){
		allsublinks.forEach(ele=>{
			ele.addEventListener('click', function(ev){
				if(ele.classList.contains('active')){
					ev.preventDefault();
				}
			});
		});
		var toggleBtn = document.querySelector('.sub-menu__toggle');
		if(toggleBtn){
			//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
			toggleBtn.addEventListener('click', function(){
				toggleBtn.parentElement.classList.toggle('open');
			});
		}
	}else if(submenuHold.length > 0){
		submenuHold[0].classList.add('hidden');
	}
	
}
submenu();


//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}